export default __webpack_public_path__ + "static/media/Telengana_Normal.c0f2a40f.svg";